import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fmtUSD = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n ?? 0);

export const fmtCompact = (n) => {
  if (n == null) return "$0";
  if (Math.abs(n) >= 1000) return `$${(n / 1000).toFixed(1)}k`;
  return fmtUSD(n);
};

export const timeAgo = (isoStr) => {
  if (!isoStr) return "—";
  const s = Math.floor((Date.now() - new Date(isoStr).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export const fmtTime = (isoStr) =>
  isoStr ? new Date(isoStr).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" }) : "";

export const fmtDate = (d) => {
  if (!d) return "—";
  const dt = new Date(d.length === 10 ? d + "T12:00:00" : d);
  return dt.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

export const STATUS_META = {
  needs_review: { label: "Needs review", tone: "blue" },
  waiting_on_employee: { label: "Waiting on employee", tone: "amber" },
  draft: { label: "Draft", tone: "neutral" },
  approved: { label: "Approved", tone: "green" },
  rejected: { label: "Rejected", tone: "red" },
  exported: { label: "Exported", tone: "violet" },
  archived: { label: "Archived", tone: "neutral" },
};

export const POLICY_META = {
  ok: { label: "Passing", tone: "green" },
  violation: { label: "Policy violation", tone: "red" },
  needs_info: { label: "Needs info", tone: "amber" },
};

// "In Status" column / filter semantics: is the expense within policy?
export const POLICY_STATUS_META = {
  ok: { label: "Yes", tone: "green" },
  violation: { label: "No", tone: "red" },
  needs_info: { label: "Needs Info", tone: "amber" },
};

export const GL_OPTIONS = [
  { code: "6000", name: "Travel — Air" },
  { code: "6010", name: "Meals & Entertainment" },
  { code: "6020", name: "Cloud & Software" },
  { code: "6030", name: "Lodging" },
  { code: "6040", name: "Ground Transport" },
  { code: "6050", name: "Office & Equipment" },
  { code: "6060", name: "Entertainment" },
  { code: "6090", name: "Miscellaneous" },
];

export const CATEGORY_OPTIONS = [
  "Lodging", "Meals", "Airfare", "Ground Transport", "Software", "Office", "Entertainment", "Other",
];

export const initials = (name) =>
  (name || "?")
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
